module.exports = __webpack_public_path__ + "img/custom-03.50dbb480.jpg";